import type { BlogPost } from "./blog";

export const BLOG_LIFESTYLE_PART1: BlogPost[] = [
  {
    "slug": "kuda-poyti-v-peterburge-s-devushkoy",
    "title": "Куда пойти в Петербурге с девушкой: 15 идей для особого вечера",
    "metaTitle": "Куда пойти в Петербурге с девушкой — 15 идей | Паруса на крыше",
    "metaDescription": "15 идей куда пойти с девушкой в Санкт-Петербурге. «Паруса на крыше» — ужин с панорамным видом, живая музыка, романтическая атмосфера.",
    "keywords": "куда пойти петербург с девушкой, идеи вечера с девушкой спб, куда сходить с девушкой петербург",
    "date": "2026-06-01",
    "category": "Lifestyle",
    "readTime": 8,
    "image": "/photos/view_sunset.webp",
    "lead": "Петербург — идеальный город для особого вечера с девушкой. Музеи, каналы, белые ночи и рестораны с видом создают фон, который работает сам. Вопрос только в том, как правильно выстроить вечер.",
    "sections": [
      {
        "heading": "15 идей для особого вечера в Петербурге",
        "body": "1. Ужин с закатом в «Парусах на крыше» (лучший старт). 2. Прогулка по каналу Грибоедова до Спаса на Крови. 3. Романтический круиз по каналам. 4. Посещение Эрмитажа + ужин. 5. Концерт в Филармонии + ужин. 6. Балет в Мариинском. 7. Прогулка по Елагинскому парку на закате. 8. Крышные экскурсии. 9. Дегустация вин в «Парусах». 10. Белые ночи на открытой террасе. 11. Разводка мостов после ужина. 12. Прогулка по Петроградке. 13. Пикник в Летнем саду (летом). 14. Театр + ужин до спектакля. 15. Авторская экскурсия + ужин.",
        "list": [
          "Ужин в «Парусах» — главная рекомендация для любого варианта",
          "Закат с высоты + живая музыка = самый лёгкий успешный вечер",
          "Прогулка по каналам — 15 минут пешком от ресторана",
          "Разводка мостов ночью — продолжение вечера после ужина"
        ]
      },
      {
        "heading": "Почему «Паруса» — лучший якорь вечера",
        "body": "Любой из 15 вариантов становится лучше, если включает ужин в «Парусах на крыше». Ресторан снимает неловкость (красивое место = темы для разговора), обеспечивает качественное время за едой, и даёт вид, который производит впечатление без ваших усилий. Рейтинг 5,0 при 2 606 отзывах — значит место работает, и не только для вас.",
        "highlight": "Лучшая комбинация: прогулка по каналу Грибоедова (30 минут) → ужин в «Парусах» с закатом → прогулка до набережной Невы. 3 часа, которые запомнятся."
      },
      {
        "heading": "Практические советы",
        "body": "Бронируйте ужин заранее (3–5 дней для выходных). Выбирайте пятницу или субботу — живая музыка без дополнительных затрат. Просите столик у окна при бронировании. Не переусложняйте программу — один-два хороших места лучше, чем пять посредственных. Телефон убирайте под стол."
      }
    ],
    "cta": {
      "text": "Забронировать особый вечер",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "peterburg-dlya-vlyublennikh",
    "title": "Петербург для влюблённых: маршруты и места",
    "metaTitle": "Петербург для влюблённых — маршруты и места | Паруса на крыше",
    "metaDescription": "Петербург для влюблённых: лучшие романтические места и маршруты. «Паруса на крыше» — главный романтический ресторан с видом на Петербург.",
    "keywords": "петербург влюблённые места, романтический петербург маршрут, романтика петербург куда пойти паре",
    "date": "2026-06-01",
    "category": "Lifestyle",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Петербург создан для влюблённых. Каналы, мосты, купола — архитектурный язык, который говорит о красоте и вечности. Собрали лучшие романтические места города.",
    "sections": [
      {
        "heading": "Самые романтические места Петербурга",
        "body": "Банковский мостик: кованые грифоны с фонарями — одна из главных романтических открыток города. Мост Поцелуев (наб. реки Мойки): традиция целоваться при проезде под мостом — туристическая, но очень петербургская. Аничков мост с конями: один из лучших мостов города. Летний сад: аллеи и скульптуры — для медленных прогулок. Шестой этаж «Парусов»: вид на весь этот Петербург сверху — лучшая романтическая точка с едой.",
        "list": [
          "Банковский мостик: кованые грифоны, фотостоп",
          "Мост Поцелуев: традиция и туристическая открытка",
          "Летний сад: аллеи для медленной прогулки",
          "«Паруса»: вид сверху на все эти места одновременно"
        ]
      },
      {
        "heading": "Маршрут для влюблённых на один вечер",
        "body": "17:00 — Казанский собор (15 минут). 17:30 — Набережная канала Грибоедова → Банковский мостик. 18:30 — Спас на Крови снаружи. 19:30 — Ужин в «Парусах на крыше» с закатом. 22:00 — Прогулка по набережной Невы. Опционально — разводка мостов (01:00+).",
        "highlight": "Лучший сезон для маршрута: июнь–август (белые ночи добавляют особый свет). Ужин в «Парусах» в 19:30 — закат будет прямо в окно."
      },
      {
        "heading": "Что ещё сделать для романтики",
        "body": "Сюрприз: живые цветы на столике в «Парусах» к приходу партнёра — согласовывается при бронировании. Фото на закате: попросите официанта снять вас у панорамного окна — лучший кадр за всю поездку. Тост: шампанское с персональным пожеланием — просто попросите."
      }
    ],
    "cta": {
      "text": "Забронировать романтический вечер",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "lifstayl-spb-vecher-v-gorode",
    "title": "Идеальный вечер в Петербурге: сценарии для разных ситуаций",
    "metaTitle": "Идеальный вечер в Петербурге — сценарии | Паруса на крыше",
    "metaDescription": "Сценарии идеального вечера в Санкт-Петербурге: для пары, для компании, для деловой встречи, для себя. «Паруса на крыше» — во всех сценариях.",
    "keywords": "идеальный вечер петербург сценарии, вечер петербург что делать, как провести вечер спб",
    "date": "2026-06-01",
    "category": "Lifestyle",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Идеальный вечер в Петербурге — разный для разных людей. Один сценарий для влюблённых, другой для деловой встречи, третий для одинокого исследователя. Вот проверенные варианты.",
    "sections": [
      {
        "heading": "Сценарий 1: Пара (романтика)",
        "body": "17:30 — Прогулка по каналам. 19:00 — Ужин в «Парусах» с закатом (столик у окна, шампанское заранее заказано). 21:30 — Прогулка по набережной. 01:00 — Разводка мостов. Итого: 6 часов, которые запомнятся на годы. Бюджет: 4 000–7 000 ₽ на двоих за ужин.",
        "list": [
          "Заказать столик у окна заранее",
          "Попросить шампанское к приходу",
          "Пятница — живая музыка бонусом",
          "После ужина — разводка мостов"
        ]
      },
      {
        "heading": "Сценарий 2: Деловой ужин",
        "body": "19:00 — Ужин в «Парусах» в выделенной зоне (тихо, деликатный сервис). Вид на Петербург как нейтральная тема для начала разговора. Бизнес-ланч в будни 12:30 — для короткой встречи. Итого: место говорит «мы серьёзные люди» без лишних слов. Бюджет: 1 500–3 000 ₽/чел.",
        "highlight": "Деловой ужин в «Парусах»: попросите при бронировании угловой столик в спокойной части зала. Персонал понимает формат."
      },
      {
        "heading": "Сценарий 3: Один в большом городе",
        "body": "Иногда лучший вечер — одному с книгой и видом. Бизнес-ланч в «Парусах» за 590 ₽ в будний день, столик у окна, ноутбук или книга, кофе. Никто не торопит. Вид на Петербург. Два часа в тишине. Иногда это лучше любой компании."
      }
    ],
    "cta": {
      "text": "Выбрать свой сценарий вечера",
      "href": "/"
    }
  },
  {
    "slug": "peterburg-weekend-marshrut",
    "title": "Выходные в Петербурге: маршрут на 2 дня",
    "metaTitle": "Выходные в Петербурге — маршрут на 2 дня | Паруса на крыше",
    "metaDescription": "Маршрут на выходные в Санкт-Петербурге — суббота и воскресенье. Что посмотреть, где поесть, как провести. «Паруса на крыше» — завтрак и ужин оба дня.",
    "keywords": "выходные петербург маршрут, уикенд петербург что делать, суббота воскресенье петербург маршрут",
    "date": "2026-06-02",
    "category": "Lifestyle",
    "readTime": 7,
    "image": "/photos/view_summer.webp",
    "lead": "Выходные в Петербурге — один из лучших вариантов для пары или небольшой компании из другого города. Два дня — достаточно, чтобы охватить главное и не устать.",
    "sections": [
      {
        "heading": "Суббота: классика центра",
        "body": "10:00 — Казанский собор. 10:30 — Эрмитаж (3–4 часа, билет онлайн). 14:00 — Бизнес-ланч в «Парусах» 590 ₽ (1 час). 15:00 — Набережная Невы, Петропавловская крепость (снаружи). 17:00 — Стрелка Васильевского острова (вид). 19:30 — Ужин в «Парусах» с закатом (2–2,5 часа). 22:00+ — Прогулка, опционально разводка мостов.",
        "list": [
          "Стратегия: 2 посещения «Парусов» в субботу — ланч + ужин",
          "Эрмитаж + вид с 6-го этажа = лучшее понимание Петербурга",
          "Стрелка Васильевского: вид на Неву бесплатно",
          "Разводка мостов: финал дня в 01:30"
        ]
      },
      {
        "heading": "Воскресенье: другой Петербург",
        "body": "10:00 — Завтрак в кафе в центре. 11:00 — Спас на Крови, Русский музей или Михайловский замок. 14:00 — Прогулка по Петроградской стороне. 16:00 — Царскосельский экспресс (опционально, если есть время). 19:30 — Финальный ужин в «Парусах» с прощальным видом на Петербург.",
        "highlight": "Финальный ужин воскресенья — не торопитесь. Это последний вечер, можно растянуть на 3 часа с вином и видом. Запомнится как главное впечатление о Петербурге."
      },
      {
        "heading": "Бюджет выходных в Петербурге",
        "body": "Отель в центре: 4 000–10 000 ₽ за 2 ночи (зависит от уровня). Питание: 2 бизнес-ланча (1 200 ₽) + 2 ужина (6 000–10 000 ₽) + завтраки в отеле. Музеи: Эрмитаж (800 ₽) + другие (1 000 ₽). Транспорт: метро + такси (1 000–2 000 ₽). Итого на двоих: 15 000–30 000 ₽ за выходные в зависимости от выбора отеля и ресторанов."
      }
    ],
    "cta": {
      "text": "Забронировать ужин на выходные",
      "href": "/"
    }
  },
  {
    "slug": "peterburgskiy-stil-zhizni",
    "title": "Петербургский образ жизни: что делают местные",
    "metaTitle": "Петербургский образ жизни — что делают местные | Паруса на крыше",
    "metaDescription": "Петербургский стиль жизни: что делают местные. Рестораны, прогулки, культура. «Паруса на крыше» — любимое место петербуржцев для особых вечеров.",
    "keywords": "петербургский образ жизни, что делают петербуржцы, местная жизнь петербург",
    "date": "2026-06-02",
    "category": "Lifestyle",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Петербуржец — особая культурная порода. Что объединяет людей этого города и как прожить один вечер «по-петербургски».",
    "sections": [
      {
        "heading": "Петербургские привычки",
        "body": "Бизнес-ланч в ресторане: в Петербурге культура хорошего обеда выше, чем в большинстве городов России. Многие горожане регулярно ходят в ресторан на обед — не на праздник, а как часть рабочего дня. Вечер в театре или на концерте: Петербург — город, где культурная программа естественна. Прогулка по центру независимо от погоды: «погода не бывает плохой» — неофициальный девиз. Ресторан с видом для особых поводов: «Паруса на крыше» — место, которое петербуржцы выбирают для событий.",
        "list": [
          "Регулярные бизнес-ланчи в хорошем ресторане",
          "Театр, филармония, музеи — не только для туристов",
          "Прогулки по центру в любую погоду",
          "Рестораны с видом для особых дней"
        ]
      },
      {
        "heading": "«Паруса» в петербургской жизни",
        "body": "За 15 лет работы «Паруса на крыше» стали частью петербургского городского ритма. Постоянные гости, которые приходят еженедельно на бизнес-ланч. Пары, которые отмечают здесь каждую годовщину. Компании, которые проводят корпоративы только здесь. Это не туристический ресторан — это место для петербуржцев.",
        "highlight": "Хотите провести вечер «по-петербургски»: бизнес-ланч в «Парусах» + прогулка по каналам + концерт или театр. Три часа — полный петербургский день."
      },
      {
        "heading": "Что привозят из Петербурга как впечатление",
        "body": "Туристы, которые возвращаются из Петербурга, чаще всего вспоминают три вещи: вид из «Парусов», прогулку по каналу Грибоедова и разводку мостов. Это не Эрмитаж и не Петергоф — хотя они важны. Это именно тот живой, городской опыт, который нельзя передать фотографией."
      }
    ],
    "cta": {
      "text": "Провести вечер как петербуржец",
      "href": "/"
    }
  },
  {
    "slug": "peterburg-bez-turistov-marshut",
    "title": "Петербург без туристов: маршрут по нетуристическим местам",
    "metaTitle": "Петербург без туристов — маршрут | Паруса на крыше",
    "metaDescription": "Нетуристический Петербург: места, которые знают местные. Дворы-колодцы, каналы, рестораны без очередей. «Паруса на крыше» — не туристическая ловушка.",
    "keywords": "петербург без туристов маршрут, нетуристический петербург, настоящий петербург куда пойти",
    "date": "2026-06-02",
    "category": "Lifestyle",
    "readTime": 7,
    "image": "/photos/view_clouds.webp",
    "lead": "Петербург туристический и Петербург настоящий — два разных города. Один — на Невском, другой — в дворах-колодцах и каналах. Маршрут для тех, кто хочет второй.",
    "sections": [
      {
        "heading": "Маршрут по настоящему Петербургу",
        "body": "Старт: Коломна (ул. Декабристов, Лоцманская ул.) — тихий квартал без туристов. Дворы-колодцы: ул. Декабристов 3, 5, 7 — типичные петербургские дворы. Набережная Пряжки: почти без туристов, вид на Мойку. Ул. Марата: локальные рестораны, кофейни, книжные. «Паруса на крыше» (Марата 5): рейтинг 5,0, но не туристическая ловушка — место, которое выбирают петербуржцы.",
        "list": [
          "Коломна: ул. Декабристов — тихая жилая Петербургская",
          "Дворы-колодцы: заходите в любую арку и смотрите наверх",
          "Ул. Марата: местная жизнь в двух шагах от центра",
          "«Паруса»: не туристический ресторан, а местное любимое место"
        ]
      },
      {
        "heading": "Почему «Паруса» — не туристическая ловушка",
        "body": "15 лет репутации. 2 606 отзывов — подавляющее большинство от жителей Петербурга и приезжих, которые вернулись снова. Рейтинг 5,0 — его не поддерживают туристы, которые приходят один раз. Его поддерживают постоянные гости. Это принципиальная разница с туристическими ресторанами на Невском.",
        "highlight": "Главный признак нетуристического ресторана: постоянные гости. В «Парусах» они есть — официанты знают их по именам."
      },
      {
        "heading": "Другие нетуристические места Петербурга",
        "body": "Ул. Рубинштейна: местный барно-ресторанный квартал. Петроградская сторона: тихие кафе вдали от Невского. Сенной рынок: настоящий городской рынок. Новая Голландия: остров-парк с кафе и событиями. Всё это — Петербург, который не видно с туристического маршрута."
      }
    ],
    "cta": {
      "text": "Посетить место, куда идут петербуржцы",
      "href": "/"
    }
  },
  {
    "slug": "kak-provesti-den-rozhdeniya-peterburg",
    "title": "Как провести день рождения в Петербурге незабываемо",
    "metaTitle": "Как провести день рождения в Петербурге незабываемо | Паруса",
    "metaDescription": "Идеи для незабываемого дня рождения в Петербурге. Маршруты, рестораны, форматы праздника. «Паруса на крыше» — ресторан для особого дня рождения.",
    "keywords": "день рождения петербург как провести, идеи день рождения петербург, незабываемый день рождения спб",
    "date": "2026-06-03",
    "category": "Lifestyle",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "День рождения в Петербурге — это возможность использовать всё, чем богат город: архитектуру, рестораны, каналы и особую атмосферу. Как выстроить день, который запомнится.",
    "sections": [
      {
        "heading": "Форматы дня рождения в Петербурге",
        "body": "Камерный ужин (2–8 человек): «Паруса на крыше», столик у окна, скидка 20% именинникам, живая музыка. Вечеринка (10–30 человек): выделенная зона в «Парусах», специальное меню, ведущий по желанию. Банкет (30–100 человек): банкетный зал с видом, профессиональная программа. Все форматы объединяет: вид на Петербург + авторская кухня + скидка именинникам.",
        "list": [
          "Камерный ужин: лучший для тех, кто ценит атмосферу",
          "Вечеринка: выделенная зона + персональный официант",
          "Банкет: зал до 300 человек + сцена + программа",
          "Скидка 20% именинникам — во всех форматах"
        ]
      },
      {
        "heading": "День рождения на крыше Петербурга: сценарий",
        "body": "18:00 — Прогулка по центру (Казанский собор, каналы) — 1 час. 19:30 — Сбор гостей в «Парусах», аперитив с видом на Петербург. 20:00 — Ужин: авторская кухня, тосты, живая музыка (если пятница/суббота). 22:00 — Торт с именем именинника. 22:30 — Прогулка на набережную. Опционально — разводка мостов.",
        "highlight": "Скидка 20% действует 7 дней до и после дня рождения. Сообщите при бронировании — это активируется автоматически. Бронирование: +7 (812) 991-10-90."
      },
      {
        "heading": "Сюрпризы для именинника в «Парусах»",
        "body": "Живые цветы на столе — к приходу именинника. Шампанское от ресторана — как сюрприз. Торт с надписью от шефа-кондитера — за 2–3 дня при бронировании. Персональная музыкальная программа — при наличии живых музыкантов в этот вечер. Все детали согласовываются при бронировании."
      }
    ],
    "cta": {
      "text": "Спланировать день рождения в «Парусах»",
      "href": "/den-rozhdeniya"
    }
  },
  {
    "slug": "muzikа-dzhaz-peterburg-restaurant",
    "title": "Джаз в ресторанах Петербурга: куда пойти на живую музыку",
    "metaTitle": "Джаз в ресторанах Петербурга — живая музыка | Паруса на крыше",
    "metaDescription": "Джаз в ресторанах Санкт-Петербурга. Где послушать живой джаз за ужином? «Паруса на крыше» — джазовые выступления по расписанию афиши.",
    "keywords": "джаз рестораны петербург, живой джаз петербург ужин, джаз-ресторан спб",
    "date": "2026-06-03",
    "category": "Lifestyle",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Джаз и хорошая кухня — одна из лучших комбинаций для вечера. В Петербурге это доступно в «Парусах на крыше» — живой джаз и авторская кухня с видом на город.",
    "sections": [
      {
        "heading": "Почему джаз и ресторан — идеальная пара",
        "body": "Джаз — единственный музыкальный жанр, который одновременно работает как фон и как главный объект внимания. Это делает его идеальным для ресторана: музыканты играют, разговор продолжается — но в момент особенно красивой импровизации все замолкают и слушают. Это не прерывает вечер, а обогащает его. В «Парусах на крыше» джаз встроен в концепцию ресторана: афиша с регулярными выступлениями, живые музыканты по пятницам и субботам.",
        "list": [
          "Джазовые дуэты и трио — по пятницам и субботам",
          "Специальные концерты по афише — несколько раз в месяц",
          "Заказная программа для мероприятий — по запросу",
          "Панорама Петербурга + джаз = особый опыт"
        ]
      },
      {
        "heading": "Что слушают в «Парусах»",
        "body": "Типичная программа: мировые джазовые стандарты (Kind of Blue, Autumn Leaves, All the Things You Are), французская шансон в джазовой аранжировке, авторские композиции исполнителей. Репертуар варьируется в зависимости от музыкантов — афиша публикуется заранее. Петербургские джазовые исполнители высокого уровня: город с богатой джазовой традицией.",
        "highlight": "Проверьте афишу перед выбором даты: совпадение с концертом делает вечер особенным без дополнительных затрат. Расписание на сайте: /afisha."
      },
      {
        "heading": "Джаз для особых поводов",
        "body": "Живая музыка к романтическому ужину: попросите музыкантов сыграть любимую песню — при наличии живых музыкантов в этот вечер это организовывается. Джаз к дню рождения: сыграют «Happy Birthday» в джазовой аранжировке. Джаз к корпоративу: специальная программа под заказ. Всё согласовывается при бронировании."
      }
    ],
    "cta": {
      "text": "Посмотреть расписание концертов",
      "href": "/afisha"
    }
  },
  {
    "slug": "kharakteristika-peterburgа-kultura",
    "title": "Культура Петербурга: что делает этот город особенным",
    "metaTitle": "Культура Петербурга — что делает город особенным | Паруса",
    "metaDescription": "Культура Санкт-Петербурга: что отличает его от других городов. История, архитектура, гастрономия. «Паруса на крыше» — место, где культура города ощущается особенно.",
    "keywords": "культура петербурга особенности, что особенного в петербурге, петербург культурная столица",
    "date": "2026-06-03",
    "category": "Lifestyle",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Петербург называют культурной столицей России — и это не преувеличение. Но что именно делает этот город культурным? И как испытать это на практике, а не только теоретически.",
    "sections": [
      {
        "heading": "Петербург: три источника особости",
        "body": "Первый: архитектура. 300+ лет европейской планировки сделали центр города уникальным ансамблем — нигде в России нет такой однородной исторической застройки. Второй: история. Столица Российской империи 200 лет — каждое здание несёт этот слой. Третий: культурные институции. Эрмитаж, Мариинский, Русский музей — три мировых учреждения в пешей доступности друг от друга.",
        "list": [
          "Архитектура: 1 700 исторических зданий под охраной",
          "История: 200 лет столичного статуса",
          "Музеи и театры: мировой класс в нескольких кварталах",
          "Гастрономия: синтез европейских традиций и северной природы"
        ]
      },
      {
        "heading": "Культура через еду",
        "body": "Гастрономия — один из главных культурных носителей. Петербургская кухня — синтез: немецкий хлеб, французские соусы, финская рыбная традиция, русские заготовки. В «Парусах на крыше» этот синтез ощущается в меню: балтийская рыба, карельские грибы, авторские сочетания. Это не туристический «борщ и пельмени» — это живая петербургская кухня.",
        "highlight": "Культурная программа одного вечера: Эрмитаж (визуальное искусство) + ужин в «Парусах» (гастрономическое искусство) + джаз (музыкальное искусство). Три вида искусства за один день."
      },
      {
        "heading": "Как горожане транслируют культуру",
        "body": "Петербуржец выбирает ресторан за авторскую кухню, а не за «сытно и дёшево». Ходит в театр, а не только в кино. Знает свой квартал до последнего двора. В этом смысле «Паруса» — культурный артефакт города: место, которое отражает то, как петербуржцы понимают хороший вечер."
      }
    ],
    "cta": {
      "text": "Стать частью культуры Петербурга — забронировать",
      "href": "/"
    }
  },
  {
    "slug": "peterburg-v-noyabre-chto-delat",
    "title": "Петербург в ноябре: что делать в самый серый месяц",
    "metaTitle": "Петербург в ноябре — что делать | Паруса на крыше",
    "metaDescription": "Что делать в Петербурге в ноябре? Как провести время в самый серый месяц города. «Паруса на крыше» — уют и вид на серый Петербург, особая атмосфера.",
    "keywords": "петербург ноябрь что делать, ноябрь петербург куда пойти, ноябрь спб что посмотреть",
    "date": "2026-06-04",
    "category": "Lifestyle",
    "readTime": 6,
    "image": "/photos/view_clouds.webp",
    "lead": "Ноябрь в Петербурге — репутация самого мрачного месяца. Но те, кто знает город, ценят именно это время: пустые музеи, дождливые набережные и особая петербургская меланхолия.",
    "sections": [
      {
        "heading": "Почему ноябрь — не худший месяц",
        "body": "Ноябрь в Петербурге: меньше туристов (очереди в Эрмитаже в 5 раз меньше, чем летом), мокрые мостовые отражают фасады — идеально для фотографии, серое небо создаёт «достоевский» свет — особая петербургская эстетика, рестораны более камерные — меньше шума, более приватно. «Паруса» в ноябре: влажный город за панорамными окнами, горячий глинтвейн, авторская кухня из сезонных продуктов.",
        "list": [
          "Эрмитаж без очередей: ноябрь — лучшее время",
          "Мокрые набережные: фотографическая красота",
          "Глинтвейн в «Парусах»: согревающий ноябрьский ритуал",
          "Сезонное меню: грибы, тыква, согревающие блюда"
        ]
      },
      {
        "heading": "Ноябрьский маршрут в Петербурге",
        "body": "Утро: Эрмитаж без очередей (3 часа в тишине). Обед: тыквенный суп в «Парусах» + горячее. Вечер: прогулка под дождём по каналу Грибоедова (с зонтом!) → горячий кофе → ужин в «Парусах» с видом на мокрый ночной Петербург. Это и есть настоящий Петербург, который не знают туристы, приезжающие только летом.",
        "highlight": "Ноябрьский вечер в «Парусах»: горячий суп + вид на мокрые крыши в серебряном дожде. Это то, что называют «петербургской красотой»."
      },
      {
        "heading": "Что заказывать в ноябре",
        "body": "Ноябрьское меню «Парусов»: грибное ризотто с белыми карельскими грибами (пик сезона к концу октября, но ещё доступны). Тыквенный крем-суп. Горячее мясное блюдо на хоспере. Глинтвейн как аперитив. Шоколадный фондан на финал. Всё это создаёт ощущение уюта в октябрьской промозглости."
      }
    ],
    "cta": {
      "text": "Забронировать ноябрьский ужин с видом",
      "href": "/"
    }
  },
  {
    "slug": "kak-splanirovat-svadbu-peterburg",
    "title": "Как спланировать свадьбу в Петербурге: полный гид",
    "metaTitle": "Как спланировать свадьбу в Петербурге — полный гид | Паруса",
    "metaDescription": "Полный гид по планированию свадьбы в Санкт-Петербурге. Выбор даты, места, ресторана. «Паруса на крыше» — свадебный банкет до 300 гостей с панорамой.",
    "keywords": "как спланировать свадьбу петербург, свадьба петербург гид планирование, организация свадьбы спб",
    "date": "2026-06-04",
    "category": "Lifestyle",
    "readTime": 9,
    "image": "/photos/view_sunset.webp",
    "lead": "Планирование свадьбы в Петербурге — задача, в которой важен правильный порядок действий. Начните не с флористики, а с главных решений: дата, формат, место.",
    "sections": [
      {
        "heading": "Шаг 1: определите дату и формат",
        "body": "Дата: лучшие сезоны — июнь-август (белые ночи, открытая терраса), май и сентябрь (тепло, меньше толп). Декабрь — зимняя свадьба. Формат: классический банкет, камерная вечеринка, выездная регистрация + банкет. Размер: до 50 гостей (интимно, каждый важен), 50–150 (стандартный банкет), 150+ (большое мероприятие).",
        "list": [
          "Лучшие даты: июнь-август (белые ночи)",
          "Май и сентябрь: тепло без летней жары",
          "Камерная свадьба (до 30 гостей): самый атмосферный формат",
          "Большая свадьба (50+): нужна профессиональная площадка"
        ]
      },
      {
        "heading": "Шаг 2: выберите место",
        "body": "Критерии места: вместимость (с комфортом, не впритык), вид и атмосфера (фото и ощущения), кухня (дегустируйте меню до подписания), сервис (как говорят с вами до мероприятия). «Паруса на крыше»: вместимость до 300 гостей, вид на Петербург, авторская кухня, 15 лет опыта свадебных мероприятий, рейтинг 5,0.",
        "highlight": "Посетите «Паруса» лично перед бронированием — договоритесь об экскурсии по залу. Место должно нравиться сразу, без «надо привыкнуть». Телефон: +7 (812) 991-10-90."
      },
      {
        "heading": "Шаг 3: спланируйте детали",
        "body": "После выбора места: согласование меню (дегустация за 2–3 месяца), выбор ведущего и музыкантов (живая музыка для атмосферы), оформление зала (флорист или ресторанные партнёры), рассадка и программа вечера (менеджер помогает). Всё делается последовательно и без спешки — при бронировании за 4–6 месяцев."
      }
    ],
    "cta": {
      "text": "Обсудить свадьбу с менеджером «Парусов»",
      "href": "/svadba"
    }
  },
  {
    "slug": "peterburgskie-vino-i-uzhin",
    "title": "Вино и ужин в Петербурге: вечер в лучшем ресторане",
    "metaTitle": "Вино и ужин в Петербурге — вечер в ресторане | Паруса на крыше",
    "metaDescription": "Вино и ужин в Петербурге. Где провести идеальный винный вечер? «Паруса на крыше» — карта вин, авторская кухня, вид на город.",
    "keywords": "вино ужин петербург вечер, винный ужин спб ресторан, вечер с вином петербург",
    "date": "2026-06-04",
    "category": "Lifestyle",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Вечер с хорошим вином и правильной едой — один из самых цивилизованных способов провести время. В Петербурге есть для этого идеальное место.",
    "sections": [
      {
        "heading": "Почему вино + вид = идеальный вечер",
        "body": "Вино замедляет время — это научный факт. Когда к этому добавляется красивый вид (закат над Петербургом или ночные огни города), вечер приобретает другое измерение: становится осознанным и запоминающимся. В «Парусах на крыше» эта комбинация встроена: карта вин + авторская кухня + панорама = основа для любого особого вечера.",
        "list": [
          "Карта вин: белые, красные, розовые, игристые, натуральные",
          "Авторская кухня: блюда, созданные с учётом сочетания с вином",
          "Вид на Петербург: лучший фон для медленного вечера",
          "Сомелье или знающий официант: помогут с выбором"
        ]
      },
      {
        "heading": "Как выстроить винный ужин",
        "body": "Аперитив: бокал игристого (просекко или шампань) с лёгкой закуской. Первое: белое вино к рыбе или морепродуктам. Второе: красное к мясному горячему. Сыр (если есть в меню): выдержанное красное или порт. Десерт: мускат или дижестив. Итого: 2,5–3 часа, 2–3 разных вина, полный гастрономический опыт.",
        "highlight": "Попросите официанта «Парусов» составить паринг под ваш выбор блюд. Это называется «wine pairing» — несколько бокалов разного вина к разным переменам. Незабываемый вечер."
      },
      {
        "heading": "Бюджет винного ужина",
        "body": "Бокал вина: 500–900 ₽. Бутылка: 1 500–5 000 ₽ и выше. Ужин: 1 200–1 800 ₽/чел. без алкоголя. Итого винный ужин на двоих с бутылкой: 5 000–9 000 ₽. Это разумная сумма за особый вечер с видом на Петербург и хорошим вином."
      }
    ],
    "cta": {
      "text": "Забронировать винный ужин",
      "href": "/"
    }
  },
  {
    "slug": "podrugi-peterbug-uzhin-devichnik",
    "title": "Вечер с подругами в Петербурге: куда пойти и что делать",
    "metaTitle": "Вечер с подругами в Петербурге — куда пойти | Паруса на крыше",
    "metaDescription": "Идеи для вечера с подругами в Санкт-Петербурге. Девичник, дегустация, ужин. «Паруса на крыше» — приватная зона, авторская кухня, вид на город.",
    "keywords": "вечер подруги петербург куда пойти, девичник спб идеи, компания подруг петербург вечер",
    "date": "2026-06-05",
    "category": "Lifestyle",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Вечер с подругами — один из лучших поводов для особого места. Когда место красивое, разговор льётся сам, фотографии получаются без усилий, а вечер растягивается на три часа.",
    "sections": [
      {
        "heading": "Идеи для вечера с подругами в Петербурге",
        "body": "Вариант 1: Ужин в «Парусах» с дегустацией вин. 5–6 позиций, краткий рассказ о каждом, лёгкие закуски. Вариант 2: Коктейльный вечер + ужин. Авторские коктейли в «Парусах» + авторская кухня. Вариант 3: Просто ужин в красивом месте. Панорама + еда + разговоры — классика, которая не устаревает. Вариант 4: Тематический вечер. Девичник перед свадьбой, день рождения подруги, просто «потому что давно не виделись».",
        "list": [
          "Дегустация вин: 4–6 позиций, организуется при бронировании",
          "Коктейльный вечер: авторские коктейли + авторская кухня",
          "Приватная зона: только ваша компания, без соседей",
          "Панорама Петербурга — лучший фон для фото компании"
        ]
      },
      {
        "heading": "Почему «Паруса» идеальны для женской компании",
        "body": "Приватность: выделенная зона не даёт посторонним нарушить атмосферу. Красивый фон: панорама Петербурга = красивые фото без студии. Вино: карта позволяет выбрать для каждого. Сервис: деликатный, не навязывается. Время: можно сидеть сколько угодно.",
        "highlight": "Бронируйте для 6–12 человек за 1–2 недели. Укажите состав компании и желаемую программу (ужин, дегустация). Телефон: +7 (812) 991-10-90."
      },
      {
        "heading": "Что заказать для женской компании",
        "body": "Лёгкие закуски на стол: карпаччо, гребешки, брускетты — делятся и создают общий стол. Каждый выбирает горячее самостоятельно. Вино: бутылка просекко на аперитив + дальше по выбору. Десерты: обязательно — торт или авторские сладкие позиции от шефа."
      }
    ],
    "cta": {
      "text": "Забронировать вечер с подругами",
      "href": "/banket"
    }
  },
  {
    "slug": "first-date-ideas-peterburg",
    "title": "Первое свидание в Петербурге: 10 идей для незабываемой встречи",
    "metaTitle": "Первое свидание в Петербурге — 10 идей | Паруса на крыше",
    "metaDescription": "10 идей для первого свидания в Санкт-Петербурге. «Паруса на крыше» — лучший вариант для первого свидания с видом на Петербург и правильной атмосферой.",
    "keywords": "первое свидание идеи петербург, идеи свидания спб, первое свидание петербург куда пойти",
    "date": "2026-06-05",
    "category": "Lifestyle",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Первое свидание в Петербурге — преимущество: город работает на вас. Нужно только правильно выбрать формат и место. 10 идей — от бюджетных до особых.",
    "sections": [
      {
        "heading": "10 идей для первого свидания в Петербурге",
        "body": "1. Ужин в «Парусах» — классика, работает всегда. 2. Прогулка по каналам + кофе. 3. Русский музей + кофе в кафе. 4. Балет в Михайловском театре (доступные цены). 5. Вечерняя прогулка по Невскому. 6. Экскурсия на крышу + кофе. 7. Кинотеатр + ужин. 8. Джазовый концерт в «Парусах». 9. Прогулка на катере по каналам. 10. Просто хороший ужин в красивом месте — «Паруса».",
        "list": [
          "«Паруса» — лучший выбор для 1-го свидания: вид снимает неловкость",
          "Джаз в «Парусах»: музыка создаёт атмосферу без усилий",
          "Прогулка по каналам: бесплатно + очень атмосферно",
          "Русский музей: если оба любят культуру"
        ]
      },
      {
        "heading": "Почему «Паруса» — идеальны для первого свидания",
        "body": "Вид снимает неловкость первых минут — есть о чём говорить без усилий. Хорошая кухня создаёт темы. Тихая живая музыка создаёт атмосферу. Не слишком пафосно и не слишком дешёво — золотая середина. Средний чек ≈ 1 300 ₽/чел. — разумно для первого свидания.",
        "highlight": "Идеальный первый визит: пятница, 19:30, стол у западного окна. Закат над Петербургом + джаз + хорошая кухня. Лучший первый вечер в городе."
      },
      {
        "heading": "Что не делать на первом свидании в ресторане",
        "body": "Не заказывайте блюда, которые сложно есть аккуратно. Не смотрите в телефон. Не выбирайте самое дорогое из меню — это создаёт давление. Не торопите официанта. Позвольте вечеру течь своим темпом — именно так работают лучшие первые свидания."
      }
    ],
    "cta": {
      "text": "Забронировать идеальное первое свидание",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "kak-otmetit-yubiley-kompanii-spb",
    "title": "Как отметить юбилей компании в Петербурге",
    "metaTitle": "Юбилей компании в Петербурге — как отметить | Паруса на крыше",
    "metaDescription": "Как отметить юбилей компании в Санкт-Петербурге? «Паруса на крыше» — банкетный зал до 300 гостей, панорама города, профессиональная сцена.",
    "keywords": "юбилей компании петербург, корпоративный юбилей спб, отметить юбилей фирмы петербург",
    "date": "2026-06-05",
    "category": "Lifestyle",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Юбилей компании — особое корпоративное событие. Это не просто корпоратив, а торжество с историей, которую нужно красиво рассказать гостям.",
    "sections": [
      {
        "heading": "Чем юбилей компании отличается от обычного корпоратива",
        "body": "Юбилей компании — мероприятие с нарративом: история создания, этапы роста, ключевые люди. Это предполагает: презентацию или видеоролик (нужен экран и проектор), официальные выступления (нужен микрофон и сцена), вручение наград или подарков (нужно время и пространство). «Паруса на крыше» оснащены всем необходимым: профессиональная сцена, звук, свет, экран.",
        "list": [
          "Сцена, микрофон, экран/проектор — в комплекте",
          "Банкетный зал до 300 гостей",
          "Менеджер мероприятий координирует программу",
          "Панорама Петербурга — особый контекст для торжества"
        ]
      },
      {
        "heading": "Программа юбилея компании",
        "body": "Cocktail hour (30 минут): сбор гостей, аперитив с видом на Петербург. Официальная часть (45–60 минут): приветственное слово руководства, видеохроника, награждение лучших сотрудников. Банкетный ужин (2 часа): несколько перемен блюд, тосты. Живая музыка или развлекательная программа (1 час): переключение на неформальную атмосферу.",
        "highlight": "Для юбилея компании рекомендуем бронировать за 2–3 месяца и встречаться с менеджером для обсуждения программы. Это не стандартный корпоратив — здесь нужна детализация."
      },
      {
        "heading": "Бюджет юбилея компании",
        "body": "Банкетное меню 2 500 ₽/чел. × количество гостей + алкоголь + программа. Для 50 гостей: 125 000 ₽ (еда) + 40 000 ₽ (алкоголь) + программа. Итого: 200 000–300 000 ₽ для 50 человек в зависимости от программы. Уточните у менеджера актуальные цены: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Обсудить юбилей компании",
      "href": "/korporativ"
    }
  },
  {
    "slug": "romantika-spb-chto-delat",
    "title": "Романтические занятия в Петербурге: 20 идей для пары",
    "metaTitle": "Романтические занятия в Петербурге — 20 идей | Паруса на крыше",
    "metaDescription": "20 романтических идей для пары в Санкт-Петербурге. «Паруса на крыше» — ужин с видом на Петербург, живая музыка, открытая терраса.",
    "keywords": "романтические занятия петербург, идеи для пары петербург, романтика спб 20 идей",
    "date": "2026-06-06",
    "category": "Lifestyle",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Петербург — один из самых романтических городов мира. 20 идей для пары: от бесплатных прогулок до особых ужинов.",
    "sections": [
      {
        "heading": "10 бюджетных романтических идей",
        "body": "1. Прогулка по каналу Грибоедова в любую погоду. 2. Кофе на закате на Стрелке Васильевского. 3. Прогулка по Летнему саду. 4. Ночная разводка мостов. 5. Прогулка в белые ночи (июнь). 6. Кофе в петербургском дворе-колодце. 7. Посмотреть закат у Петропавловской крепости. 8. Пройти весь Невский пешком. 9. Посидеть у канала на ступенях. 10. Прогулка по Елагинскому острову.",
        "list": [
          "Все 10 идей — бесплатно или до 500 ₽ на двоих",
          "Белые ночи (июнь): любая из этих идей + особое небо",
          "Канал Грибоедова: работает в любую погоду",
          "Разводка мостов: 01:00–05:00, с апреля по ноябрь"
        ]
      },
      {
        "heading": "10 идей с расходами",
        "body": "1. Ужин в «Парусах» с закатом (лучшее). 2. Круиз по каналам вечером. 3. Балет в Михайловском. 4. Дегустация вин в «Парусах». 5. Ужин при свечах + живой джаз (пятница/суббота «Паруса»). 6. Петергоф + ужин вечером. 7. Крышная экскурсия + кофе. 8. Спа-день + ужин. 9. Пикник в парке + вино (летом). 10. Фотосессия на рассвете + завтрак.",
        "highlight": "Лучшая комбинация: прогулка по каналам (бесплатно) + ужин в «Парусах» с закатом (3 000–5 000 ₽ на двоих) + ночная разводка мостов. 6 часов, которые запомнятся на годы."
      },
      {
        "heading": "Как сделать любую идею особенной",
        "body": "Небольшие детали делают разницу: заказать цветы заранее (в «Парусах» — при бронировании), приготовить тост или произнести его за столом, выключить телефон на время ужина, сфотографировать что-то незаметно для партнёра — момент, который запомнится."
      }
    ],
    "cta": {
      "text": "Начать вечер с бронирования",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "gid-peterburg-kultura-gastro",
    "title": "Петербург: культурно-гастрономический гид для знатоков",
    "metaTitle": "Петербург: культурно-гастрономический гид | Паруса на крыше",
    "metaDescription": "Культурно-гастрономический гид по Санкт-Петербургу для знатоков. Музеи, театры, рестораны. «Паруса на крыше» — главный гастрономический адрес города.",
    "keywords": "культурно-гастрономический гид петербург, гастрономический туризм петербург, петербург гастро культура",
    "date": "2026-06-06",
    "category": "Lifestyle",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Для знатока Петербурга — не туриста, а человека, который хочет понять город глубже — нужен другой путеводитель. Не «Эрмитаж + Невский», а «что едят, слушают и смотрят те, кто здесь живёт».",
    "sections": [
      {
        "heading": "Гастрономия: адреса для знатока",
        "body": "«Паруса на крыше» (ул. Марата 5): авторская кухня с продуктами Северо-Запада, вид на город, живая музыка. Рейтинг 5,0, работают с 2009 года. Ресторанная улица Рубинштейна: 15–20 заведений разных концепций на 500 метрах. Сенной рынок: настоящий городской рынок, лучшие петербургские продукты. Кофейни Петроградки: specialty coffee культура. Пышечная (ул. Желябова): легендарное место с 1958 года.",
        "list": [
          "«Паруса»: главный адрес для особого ужина",
          "Рубинштейна: разнообразие концепций",
          "Сенной рынок: локальные продукты",
          "Пышечная: петербургская традиция с 1958 года"
        ]
      },
      {
        "heading": "Культура: для тех, кто ищет нестандартное",
        "body": "Главный штаб Эрмитажа: современное искусство в Эрмитаже — меньше туристов, больше глубины. Новая сцена Мариинского: лучшая акустика в городе. Лофт Проект Этажи: современное искусство и события. Музей Достоевского: самый петербургский из всех музеев. Государственная Академическая Капелла: лучшая классическая музыка в историческом зале.",
        "highlight": "Идеальный культурно-гастрономический день: утро Главный штаб Эрмитажа → ланч в «Парусах» → вечер Государственная Капелла → ужин после концерта."
      },
      {
        "heading": "Что читать о Петербурге перед визитом",
        "body": "Достоевский «Белые ночи» (короткая, самая петербургская повесть). Пушкин «Медный всадник» (Петербург в стихах). Гоголь «Невский проспект» (лучший портрет главной улицы). Бродский: стихи о Петербурге (его «Венецианские строфы» — и о Петербурге тоже). После этого чтения город открывается совсем по-другому."
      }
    ],
    "cta": {
      "text": "Гастрономический Петербург начинается здесь",
      "href": "/"
    }
  },
  {
    "slug": "interesnye-mesta-spb-ne-dlya-turistov",
    "title": "Интересные места Петербурга, о которых не знают туристы",
    "metaTitle": "Интересные места Петербурга не для туристов | Паруса на крыше",
    "metaDescription": "Интересные места Санкт-Петербурга, о которых не знают туристы. Дворы, рынки, местные рестораны. «Паруса на крыше» — место, куда идут петербуржцы.",
    "keywords": "интересные места петербург не для туристов, скрытые места петербург, нетуристический спб места",
    "date": "2026-06-06",
    "category": "Lifestyle",
    "readTime": 7,
    "image": "/photos/view_clouds.webp",
    "lead": "За Невским и Эрмитажем скрывается другой Петербург: дворы-колодцы, местные рынки, рестораны без очередей и места, куда ходят только те, кто знает.",
    "sections": [
      {
        "heading": "Места, которые знают только местные",
        "body": "Дворы-колодцы Коломны: ул. Декабристов 3, 5, 7 — зайдите в любую арку. Новая Голландия: остров-парк с кафе и арт-пространством, появился совсем недавно. Измайловский рынок (в сезон): настоящий петербургский рынок выходного дня с фермерскими продуктами. Кофейни Петроградки: ул. Большая Пушкарская — лучшая specialty coffee культура. «Паруса на крыше» (ул. Марата 5): 15 лет репутации, 5,0 рейтинг, любимое место петербуржцев — не в туристических маршрутах.",
        "list": [
          "Дворы Коломны: пустые и аутентичные",
          "Новая Голландия: арт + отдых + кофе",
          "Измайловский рынок: по субботам-воскресеньям",
          "«Паруса»: место петербуржцев, а не туристов"
        ]
      },
      {
        "heading": "Почему «Паруса» — не туристическое место",
        "body": "15 лет репутации среди петербуржцев. Рейтинг 5,0 при 2 606 отзывах — их поддерживают постоянные гости. Нет туристического меню «борщ и пельмени» — авторская кухня с локальными продуктами. Нет агрессивного маркетинга на улице. Это место, куда идут отмечать важное — день рождения, годовщину, приехавших друзей из Москвы.",
        "highlight": "Скажите коренному петербуржцу адрес «Паруса на крыше, ул. Марата 5» — он кивнёт с уважением. Это маркер хорошего вкуса в городе."
      },
      {
        "heading": "Маршрут нетуристического Петербурга",
        "body": "Утро: кофе в specialty кофейне на Петроградке. День: Новая Голландия (погулять, покофейничать). Обед: бизнес-ланч в «Парусах» (590 ₽, вид на Петербург). После обеда: Измайловский рынок (суббота-воскресенье). Вечер: ужин в «Парусах» или на ул. Рубинштейна. Этот маршрут ни разу не пересечётся с туристическими толпами."
      }
    ],
    "cta": {
      "text": "Местное место для местного вечера",
      "href": "/"
    }
  }
];
